import * as React from 'react'
import { Callout } from '@blueprintjs/core';
import { Link } from 'gatsby';
import { FiExternalLink } from 'react-icons/all';
import HelpButtons from './HelpButtons';

interface IInitializationErrorProps {
    errorName: string;
    title: string;
}

const InitializationError: React.FC<IInitializationErrorProps> = (props) => (
    <>
        <Callout icon='info-sign' title={`Initialization Error: ${props.errorName}`}/>
        <div className='p-1 mt-3'>
            <h3 className='text-xl font-bold'>
                {props.title}
            </h3>
            <div className='my-2 max-w-xl text-large text-gray-700'>
                {props.children}
            </div>
        </div>
        <hr className='my-5'/>
        <HelpButtons/>
    </>
)

export const ConnectionLostCallout: React.FC = () => (
    <InitializationError errorName='Connection Lost' title="It seems that we've lost connection to the server">
        <p>
            The connection to the server was interrupted. To restore the connection, please reload the page.
        </p>
        <button
            className='mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-cyan-700 hover:bg-cyan-800'
            onClick={() => window.location.reload()}
        >
            Reload page
        </button>
    </InitializationError>
)

export const ComputeLimitExceededPleaseSignInCallout: React.FC = () => (
    <InitializationError errorName='Server Busy' title='Whoops – it looks like this application is very popular 🙌'>
        <p>
            The server running this application is under a high load at the moment.
            Please try again later ⏰
            <br/><br/>
            Alternatively, if you{' '}
            <Link to='/sign-in/' className='inline-flex font-bold'>
                sign in <FiExternalLink className='mt-1 ml-1'/>
            </Link> we know that you are not a robot and can start
            another server right away!
        </p>
    </InitializationError>
)

export const ComputeLimitExceededPleaseContactBioLibCallout: React.FC = () => (
    <InitializationError errorName='Server Busy' title='Whoops – it looks like this application is very popular 🙌'>
        <p>
            The server running this application is under a high load at the moment.
            Please try again later ⏰
            <br/><br/>
            Alternatively, you can reach out to us{' '}
            <Link to='/contact/' className='inline-flex font-bold'>
                here <FiExternalLink className='mt-1 ml-1'/>
            </Link> to get additional server capacity.
        </p>
    </InitializationError>
)
